import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyD4lXyxHv7CBoJIQN_Lz0_BYNrqK7Y4Dvg",
  authDomain: "dolphinwebsite.firebaseapp.com",
  projectId: "dolphinwebsite",
  storageBucket: "dolphinwebsite.firebasestorage.app",
  messagingSenderId: "749207140349",
  appId: "1:749207140349:web:9421ad0e83c40659abcb94"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export default app;